import '../scss/style.scss';
import './polyfill';
import { openNav } from './navigation';
import { button } from './button';
import { scroll } from './scroll';
import { slideIn } from './slideIn';
import { parallax } from './parallax';

console.log('index.js is loading!!');

window.addEventListener('DOMContentLoaded', () => {
  openNav();
  button();
  scroll();
  slideIn();
  parallax();
});
